export const FirebaseConfig = {
  apiKey: "AIzaSyBBccynRcDsr0yU1-kurhQH46gtNAYVqAA",
  authDomain: "inyan-sandbox-1548943038960.firebaseapp.com",
  databaseURL: "https://inyan-sandbox-1548943038960.firebaseio.com"
};